import React from "react";
import { Cloud, Heart, Plane } from "lucide-react";

// Decorative aviation sky: drifting clouds + a little Ginger Heart plane. Purely visual.
export function SkyBackdrop() {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden>
      <Cloud className="absolute -left-6 bottom-[8%] text-white/70 animate-floatySlow" size={88} fill="white" strokeWidth={1} />
      <Cloud className="absolute right-[10%] top-[10%] text-white animate-floaty" size={64} fill="white" strokeWidth={1} />
      <Cloud className="absolute left-[44%] -bottom-4 text-white/60 animate-floatySlow" size={56} fill="white" strokeWidth={1} />
      <Cloud className="absolute right-[2%] bottom-[6%] text-white/60 animate-floaty hidden md:block" size={72} fill="white" strokeWidth={1} />
      <div className="absolute top-2 md:top-4 -left-20 opacity-70 animate-[skyfly_22s_linear_infinite] flex items-center gap-1 text-[#E8435A]">
        <Plane size={34} fill="#fff" strokeWidth={2} className="rotate-45" />
        <Heart size={14} fill="#E8435A" />
      </div>
      <style>{`@keyframes skyfly{0%{transform:translateX(0)}100%{transform:translateX(120vw)}}
        @media (prefers-reduced-motion: reduce){[class*="skyfly"]{animation:none}}`}</style>
    </div>
  );
}
